import {useEffect, useState} from 'react';
import {listOpcionaisDaLicenca} from './LicencasService';
import {getBackendMessage, normalizeOpcionaisContratados} from './licencasUtils';

/*
 * Opcionais contratados de cada assinatura, por id da licença: `{items}` quando carregou, `{error}` quando não, e
 * nada enquanto carrega. Substituem os módulos do JSON `recursos_adicionais`, que a limpeza da fase 5 apaga.
 */
export function useOpcionaisContratados(licencaIds = []) {
    const chave = licencaIds.filter(Boolean).join(',');
    const [porLicenca, setPorLicenca] = useState({});

    useEffect(() => {
        const ids = chave ? chave.split(',') : [];
        let ativo = true;
        setPorLicenca({});
        Promise.all(ids.map((id) => listOpcionaisDaLicenca(id)
            .then((response) => [id, {items: normalizeOpcionaisContratados(response)}])
            .catch((error) => [id, {error: getBackendMessage(error, 'Não foi possível carregar os opcionais.')}])))
            .then((pares) => {
                if (ativo) setPorLicenca(Object.fromEntries(pares));
            });
        return () => {
            ativo = false;
        };
    }, [chave]);

    return porLicenca;
}
